// src/components/Shared/LoadingOverlay.jsx
// Full-screen or container loading overlay with retry option

import React from 'react';
import BigButton from './BigButton';
import { IconAlertTriangle } from './FigmaIcons';

const LoadingOverlay = ({
	show = true,
	message = 'Loading...',
	fullScreen = false,
	error = null,
	onRetry = null,
}) => {
	if (!show && !error) return null;

	const overlayStyle = {
		position: fullScreen ? 'fixed' : 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(255, 255, 255, 0.9)',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: fullScreen ? 9999 : 100,
		padding: '20px',
	};

	const contentStyle = {
		textAlign: 'center',
		maxWidth: '300px',
	};

	const spinnerStyle = {
		width: '48px',
		height: '48px',
		marginBottom: '16px',
	};

	const messageStyle = {
		fontSize: '18px',
		color: error ? '#dc3545' : '#212529',
		marginBottom: error ? '16px' : '0',
		fontWeight: '500',
	};

	const errorDetailStyle = {
		fontSize: '14px',
		color: '#6c757d',
		marginBottom: '16px',
	};

	return (
		<div style={overlayStyle}>
			<div style={contentStyle}>
				{!error && (
					<div 
						className="spinner-border text-primary" 
						role="status" 
						style={spinnerStyle}
					>
						<span className="visually-hidden">Loading...</span>
					</div>
				)}
				
				{error ? (
					<>
						<div className="ev-empty-state-icon" aria-hidden="true" style={{ background: 'var(--ev-danger-soft)', color: 'var(--ev-danger)' }}>
							<IconAlertTriangle className="ev-icon-svg" />
						</div>
						<p style={messageStyle}>Something went wrong</p>
						<p style={errorDetailStyle}>{error}</p>
						{onRetry && (
							<BigButton variant="primary" onClick={onRetry}>
								Try again
							</BigButton>
						)}
					</>
				) : (
					<p style={messageStyle}>{message}</p>
				)}
			</div>
		</div>
	);
};

export default LoadingOverlay;

